import React, { useEffect } from 'react';
import { CheckCircle2, XCircle } from 'lucide-react';
import { useOptionsBasket } from './OptionsBasketContext';
import OptionsBasketPanel from './OptionsBasketPanel';
import './OptionsBasketDrawer.css';

// Thin overlay chrome around the shared OptionsBasketPanel (leg list,
// margins, place) — reachable via the floating basket button from any chain
// page. The toast lives here (not in the panel) because this component is
// always mounted at the App root, so it can still surface a toast fired
// while the drawer itself is closed (e.g. an "Added to basket" notification
// from AddContractModal on some other page).
const OptionsBasketDrawer = () => {
    const { isDrawerOpen, setIsDrawerOpen, toast } = useOptionsBasket();

    // Esc closes the overlay — Ctrl/Cmd+Enter (place the basket) is handled
    // inside OptionsBasketPanel itself, so it works the same way whether the
    // panel is shown here (the drawer) or inline on the /order-basket page.
    useEffect(() => {
        if (!isDrawerOpen) return;
        const handleKeyDown = (e) => {
            if (e.key === 'Escape') setIsDrawerOpen(false);
        };
        document.addEventListener('keydown', handleKeyDown);
        return () => document.removeEventListener('keydown', handleKeyDown);
    }, [isDrawerOpen, setIsDrawerOpen]);

    return (
        <>
            {isDrawerOpen && (
                <div className="opt-drawer-overlay" onClick={() => setIsDrawerOpen(false)}>
                    <div className="opt-drawer-shell" onClick={(e) => e.stopPropagation()}>
                        <OptionsBasketPanel onClose={() => setIsDrawerOpen(false)} />
                    </div>
                </div>
            )}

            {toast.show && (
                <div className={`opt-basket-notification ${toast.type}`}>
                    {toast.type === 'success' ? <CheckCircle2 size={16} /> : <XCircle size={16} />}
                    <span>{toast.message}</span>
                </div>
            )}
        </>
    );
};

export default OptionsBasketDrawer;
